import React from 'react';
import ReactHowler from 'react-howler';

class Music extends React.Component<{},{playing: boolean, volume: number}> {
  constructor (props: any) {
    super(props)

    this.state = {
      volume: 0.0,
      playing: false
    }
    this.handlePress = this.handlePress.bind(this)
  }

  handlePress () {
    if(this.state.playing) {
      if(this.state.volume === 0.5)
      {
        this.setState({
          volume: 0.0,
          playing: false
        })
      }
      else
      {
        this.setState({
          volume: 0.5,
          playing: true
        })
      }
        
    }
    else {
        this.setState({
            volume: 1.0,
            playing: true
          })
    }
    
  }

  render () {
    let button;
    if(this.state.playing) {
      if(this.state.volume === 1.0) {
        button = <button onClick={this.handlePress} className='mini-buttons' id='full-volume-button'/>;
      }
      else {
        button = <button onClick={this.handlePress} className='mini-buttons' id='mid-volume-button'/>;
      }
    }
    else {
      button = <button onClick={this.handlePress} className='mini-buttons' id='mute-volume-button'/>;
    }
    return (
      <div>
        <ReactHowler
          src={process.env.PUBLIC_URL + 'music2.mp3'}
          playing={this.state.playing}
          volume={this.state.volume}
          loop={true}
        />
        {button}
      </div>
    )
  }
}

export default Music